import { render } from "./SearchFormItem.vue?vue&type=template&id=644500ff"
import script from "./SearchFormItem.vue?vue&type=script&lang=js"
export * from "./SearchFormItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__